module.exports = __webpack_public_path__ + "static/img/home_header_bg_01.d5117aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_header_bg_01.png
// module id = 2Yih
// module chunks = 34